import ChartTypeSelector from './ChartTypeSelector';
import TimeframeTabs from './TimeframeTabs';
import IndicatorPicker from './IndicatorPicker';

const ChartToolbar = ({
  chartTypeOptions,
  chartType,
  onChartTypeChange,
  timeframeOptions,
  timeframe,
  onTimeframeChange,
  indicatorOptions,
  selectedIndicators,
  onIndicatorsChange,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 dark:border-white/[0.06]">
      <div className="flex flex-wrap items-center gap-3">
        <TimeframeTabs options={timeframeOptions} active={timeframe} onChange={onTimeframeChange} />
        <div className="w-px h-5 bg-gray-200 dark:bg-white/[0.06]" />
        <ChartTypeSelector options={chartTypeOptions} value={chartType} onChange={onChartTypeChange} />
      </div>
      <IndicatorPicker options={indicatorOptions} active={selectedIndicators} onChange={onIndicatorsChange} />
    </div>
  );
};

export default ChartToolbar;
